import React, { useState } from "react"
import BottomCtaNavigation from "./BottomCtaNavigation"

function SurveyNavigation({
  currentSection,
  lastPage,
  nextDisabled, // This disables the next button if the user has not answered all the questions
  onNextStep,
  onPreviousStep,
  onSubmit,
}) {
  const [inflight, setInflight] = useState(false)

  const onClickSubmit = () => {
    setInflight(true)
    onSubmit()
  }

  return (
    <BottomCtaNavigation
      currentSection={currentSection}
      lastPage={lastPage}
      inflight={inflight}
      nextDisabled={nextDisabled}
      doneDisabled={inflight}
      onNextStep={onNextStep}
      onPreviousStep={onPreviousStep}
      onDone={onClickSubmit} />
  )
}

export default SurveyNavigation